import upperFirst from '@Ravnur-Inc/nanoutils/string/upperFirst';

import converter from './converter';

const toBackendFormat = converter(upperFirst);

export default toBackendFormat;
